'use strict';

var cov_1obg5mper4 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/createComponentModal/createComponentModal.js',
        hash = 'fe97fae7a30782e993958e5dde15f2c1ae97cea5',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/createComponentModal/createComponentModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 67
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 55
                }
            },
            '5': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 10
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 31
                }
            },
            '7': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 32,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 42
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 34,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewComponentModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 49
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'CreateComponentModalController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 80
                    },
                    end: {
                        line: 33,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 24,
                        column: 29
                    },
                    end: {
                        line: 24,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 41
                    },
                    end: {
                        line: 26,
                        column: 9
                    }
                },
                line: 24
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 28,
                        column: 33
                    },
                    end: {
                        line: 28,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 45
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 28
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 29,
                        column: 46
                    },
                    end: {
                        line: 29,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 67
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                },
                line: 29
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1obg5mper4.s[0]++;
(function () {
    'use strict';

    cov_1obg5mper4.f[0]++;
    cov_1obg5mper4.s[1]++;
    angular.module('app').service('NewComponentModalService', NewComponentModalService);

    /* @ngInject */
    function NewComponentModalService($mdDialog) {
        cov_1obg5mper4.f[1]++;
        cov_1obg5mper4.s[2]++;

        this.display = function () {
            cov_1obg5mper4.f[2]++;
            cov_1obg5mper4.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createComponentModal/createComponentModal.html',
                controller: CreateComponentModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateComponentModalController($scope, $mdDialog, ComponentsTable) {
        cov_1obg5mper4.f[3]++;
        cov_1obg5mper4.s[4]++;

        $scope.newComponent = ComponentsTable.$build();

        cov_1obg5mper4.s[5]++;
        $scope.closeDialog = function () {
            cov_1obg5mper4.f[4]++;
            cov_1obg5mper4.s[6]++;

            $mdDialog.cancel();
        };

        cov_1obg5mper4.s[7]++;
        $scope.createComponent = function () {
            cov_1obg5mper4.f[5]++;
            cov_1obg5mper4.s[8]++;

            $scope.newComponent.$save().$then(function (component) {
                cov_1obg5mper4.f[6]++;
                cov_1obg5mper4.s[9]++;

                $mdDialog.hide(component);
            });
        };
    }
})(angular);